// @flow

export default {
  appLinkAndroid: 'https://play.google.com/store/apps/details?id=com.guesthug',
  appLinkIos:
    'https://apps.apple.com/gb/app/guesthug-short-let-management/id1407317649?ls=1',
};
